const PhoneFormatter = (phone) => {
    if (String(phone).startsWith("+")) {
        return phone;
    } else {
        return `+${phone}`
    }
}

export default PhoneFormatter